import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { darken, lighten } from '@mui/material/styles';

import appLogo from "../../../../images/website-images/logos/app-logo.png";

import MoneyBackGuaranteeImage from "../../../../images/website-images/money-back-guarantee.png"
import SecuredImage from "../../../../images/website-images/secured.png"
import CancelAnyTimeImage from "../../../../images/website-images/cancel-any-time.png"
import {
  Button,
  Box,
  Typography
} from "@mui/material";

import { getStripeSessionDetails, completeSuccessfulSubscription } from "../../../../common/FunctionCalls";

import { useNavigate, Link } from 'react-router-dom';

import {db} from '../../../../firebaseConfig';

import { collection, query, where, doc, getDoc,getDocs, updateDoc, serverTimestamp } from "firebase/firestore";

import { getAuth, onAuthStateChanged } from "firebase/auth";


export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  const navigate = useNavigate();
  
  useEffect(() => {
    // You can call your backend to confirm the session, store subscription, etc.
    console.log("Checkout successful. Session ID:", sessionId);

    const fetchSessionDetails = async () => {

      const auth = getAuth();

      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          console.log("User is not signed in yet.");
          return;
        }

      try {

        if (sessionId !== null && sessionId !== "")
        {
         //   console.log("auth:"+auth);

          //  console.log("auth.currentUser:"+auth.currentUser);

          //  console.log("auth.currentUser.getIdToken():"+auth.currentUser.getIdToken());

            const sessionInfo = await getStripeSessionDetails(sessionId,auth);
            
           // console.log("Session Info:", sessionInfo);
       
            if (sessionInfo != null)
            {
                const subscriptionId = sessionInfo.subscriptionId;
                const customerId = sessionInfo.customerId;

                console.log("subscriptionId:"+subscriptionId);
                console.log("customerId:"+customerId);

                const compltedResults = await completeSuccessfulSubscription(sessionId, customerId, subscriptionId, auth);
                
                localStorage.setItem("testMode", "false");
                
                console.log("Updated records with subscription info:"+JSON.stringify(compltedResults));

            }
        }

        // Do something with sessionInfo
      } catch (error) {
        console.error("Error fetching session details:", error);
      }

    });

    };
  
    if (sessionId) {
      fetchSessionDetails();
    }

  }, [sessionId]);

  return (
<div style={{ 
  minHeight: '100vh', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center', 
  justifyContent: 'start', 
  backgroundColor: '#f9f9f9', 
  paddingTop: '0px' 
}}>

<Box
  mt={3}
  sx={{
    width: '400px',
    marginXXX: 'auto',
    border: '1px solid #ddd',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: '24px',
    backgroundColor: '#ffffff',
    minHeight: '420px',

    zIndex: 1,
    position: 'relative',

  }}
>


  <Box textAlign="center" pb={1}>

      <img
          src={appLogo}
          alt="App Logo"
          style={{ height: 85, cursor: "pointer" }}
          onClick={() => navigate("/")}
      />
        
      <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
      Welcome aboard!
      </Typography>
  </Box>


  <Box textAlign="left" pb={1}>
    <Typography variant="body2" sx={{ fontSize: '16px', paddingBottom:'0px', paddingTop:'16px' }}>
    
    <p>Thank you for subscribing — we're thrilled to have you with us! </p>

    <p>You’ve just unlocked access to powerful tools designed to make your workflows simpler, stay organized and help you grow.</p>

    <p>Get ready for faster results, smarter insights, and seamless collaboration.</p>

    <p>Let’s make great things happen.</p>

    </Typography>
  </Box>

  <Box textAlign="center" pb={1} sx={{paddingTop:'25px', paddingBottom:'15px'}}>
      <Button
        variant="contained"
        onClick={() => navigate('/app')}
        sx={{
          backgroundColor: lighten('#1B263B', 0.1),
          '&:hover': {
            backgroundColor: darken('#1B263B', 0.1),
          },
          width:'100%',
          height:'40px'
        }}
      >
        Take me to the application
      </Button>
    </Box>
 
</Box>

          {/* Footer Links - Full width below grid */}
          <Box
            sx={{
              gridColumn: "1 / -1", // Span both columns
              display: "flex",
              gap: 2,
              mt: 4,
            }}
          >
            <Link to="/" variant="body2">
              Home
            </Link>

            <Link to="/terms-of-service"  target="_blank" variant="body2">
            Terms of Service
            </Link>
          </Box>



{/* Background Triangle Content*/}
  <Box
    sx={{
      position: "fixed",     // Stick to screen corner
      bottom: 0,             // Align to bottom
      right: 0,              // Align to right
      zIndex: 99,
      pointerEvents: "none", // Allows clicks to pass through
      p: 2,                  // Optional padding
      display: { xs: "none", md: "block" } 
    }}
  > 
      <img src={MoneyBackGuaranteeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={CancelAnyTimeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={SecuredImage} style={{height:'100px'}}/>
      
  </Box>
  

{/* Bottom triangle */}
<Box
  sx={{
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: 0,
    height: 0,
    borderLeft: '100vw solid transparent',
    borderBottom: '460px solid #1B263B',
    display: { xs: "none", md: "block" },
    zIndex: 0,
    pointerEvents: 'none', // So it doesn't block clicks
  }}
/>

</div> 
  );
}
